export * from './bounce-in-and-out.directive';
export * from './fade-in-and-out.directive';
export * from './grow-in-shrink-out.directive';
export * from './swing-in-and-out.directive';



// WEBPACK FOOTER //
// ./libs/ngx-animations/src/directives/index.ts